import { useMemo } from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const WEAK_THRESHOLD = 50
const FAIR_THRESHOLD = 70

const getMeter = (pwd) => {
    if (!pwd || pwd.length < 8) return 0;
    const letterWeight = 5.0;
    const typeWeight = 10.0;
    const lengthBase = 1.4;
    const lengthWeight = 10.0;
    const maxValue = 150;

    let letters = {};
    let meterVal = 0;
    for (let i = 0; i < pwd.length; i++) {
        letters[pwd[i]] = (letters[pwd[i]] || 0) + 1;
        meterVal += letterWeight / letters[pwd[i]];
    }
    let types = {
        digits: /\d/.test(pwd),
        lower: /[a-z]/.test(pwd),
        upper: /[A-Z]/.test(pwd),
        symbol: /\W/.test(pwd),
    };
    let typeCount = 0;
    for (let t in types) {
        typeCount += types[t] ? 1 : 0;
    }
    meterVal += (typeCount - 1) * typeWeight + Math.pow(lengthBase, (pwd.length - 8)) * lengthWeight;
    if (meterVal > maxValue) meterVal = maxValue;
    return parseInt(meterVal / maxValue * 100);
};

const PasswordMeter = ({ password, pwnedPassword }) => {
    const meter = useMemo(() => getMeter(password), [password]);

    if (!password) return null;

    const getBarStyle = () => {
        if (pwnedPassword) return 'danger';
        if (meter < WEAK_THRESHOLD) return 'danger';
        if (meter < FAIR_THRESHOLD) return 'warning';
        return 'success';
    };

    const getBarText = () => {
        if (pwnedPassword) return 'Weak / Easily Guessed Password';
        if (meter < WEAK_THRESHOLD) return 'Weak';
        if (meter < FAIR_THRESHOLD) return 'Fair';
        return 'Strong';
    };

    const getProgressColor = (style) => {
        if (style === 'danger') return 'error';
        if (style === 'success') return 'success';
        return 'warning';
    };

    const barStyle = getBarStyle();

    return (
        <Box sx={{ width: '300px', py: 0.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ flexGrow: 1 }}>
                    <LinearProgress
                        variant="determinate"
                        value={meter}
                        color={getProgressColor(barStyle)}
                        aria-label={`Password strength: ${getBarText()}`}
                        aria-valuenow={meter}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        sx={{ height: 20, borderRadius: 1 }}
                    />
                </Box>
                <Typography variant="body2" sx={{ minWidth: 'max-content', fontSize: '12px' }}>
                    {getBarText()}
                </Typography>
            </Box>
        </Box>
    );
};

export default PasswordMeter;
